import { makeStyles, createStyles, Theme } from "@material-ui/core";

export { useUserAreaStyles };

const useUserAreaStyles = makeStyles((theme: Theme) =>
	createStyles({
		logoutButton: {
			padding: 10,
			margin: 5,
			marginBottom: 0,
		},
		logoutButtonSmall: {
			justifyContent: "center",
			alignContent: "center",
			margin: 5,
		},
		userArea: {
			textAlign: "center",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			minWidth: 250,
		},
		userAreaSmall: {
			textAlign: "center",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
		},
		userAreaImage: {
			width: 80,
			height: 80,
			padding: 2,
			margin: 10,
			zIndex: 1,
			position: "relative",
			borderRadius: "50%",
			border: `1px solid ${theme.palette.primary.main}`,
			backgroundColor: "white",
			alignSelf: "center",
		},
		userAreaImageSmall: {
			width: 40,
			height: 40,
			padding: 2,
			zIndex: 1,
			position: "relative",
			borderRadius: "50%",
			border: `1px solid ${theme.palette.primary.main}`,
			backgroundColor: "white",
			alignSelf: "center",
		},
		userAreaName: {
			fontSize: "1.2rem",
			margin: 10,
		},
		userAreaDetails: {
			display: "flex",
			justifyContent: "space-evenly",
		},
		userAreaDetailsSmall: {
			display: "flex",
			justifyContent: "space-evenly",
			flexDirection: "column",
		},
		userAreaDetailHeader: {
			fontSize: "1.2rem",
		},
		userAreaDetailTagline: {
			fontSize: "0.8rem",
		},
	})
);
